
import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  RuleActionDefinition,
  RuleArchiveEntry,
  RuleConditionDefinition,
  RuleCustomValue,
  RuleEvent,
} from '@/types';
import {
  describeArchivedRule, describeChanges, DescribedItem, DescribedRule,
} from '@/helpers/ruleArchive';
import { isCustomValueDisplayable } from '@/helpers/ruleHelpers';
import RuleCustomValueDisplay from './RuleCustomValueDisplay.vue';

// Una regola del vecchio portale, in sola lettura, con le stesse etichette che
// l'editor usa per una regola viva (segnalazione del cliente
// OwlCaveLabs/syndesia-l2c-support#2). Lo usano sia la lista dell'archivio, nella
// riga espansa, sia l'editor quando la regola viene recuperata: la stessa
// descrizione nei due posti, cosi' non possono divergere.
@Component({ components: { RuleCustomValueDisplay } })
export default class RuleArchivePayload extends Vue {
  @Prop({ type: Object, required: true }) readonly entry!: RuleArchiveEntry;

  get events(): RuleEvent[] { return this.$store.getters.ruleEvents || []; }

  get conditionDefinitions(): RuleConditionDefinition[] {
    return this.$store.getters.ruleConditionDefinitions || [];
  }

  get actionDefinitions(): RuleActionDefinition[] {
    return this.$store.getters.ruleActionDefinitions || [];
  }

  get described(): DescribedRule {
    return describeArchivedRule(
      this.entry.payload,
      this.conditionDefinitions,
      this.actionDefinitions,
    );
  }

  get eventName(): string {
    const codename = this.entry.eventCodename;
    if (!codename) return '';
    const found = this.events.find((e) => e.codename === codename);
    return found ? found.name : codename;
  }

  // L'ordine con cui girava nel vecchio portale. Sta nel payload e non fra le
  // colonne della voce d'archivio, quindi puo' mancare.
  get order(): number | null {
    const payload: any = this.entry.payload;
    return payload && typeof payload.order === 'number' ? payload.order : null;
  }

  get changes(): string[] {
    return describeChanges(this.entry.changes, this.actionDefinitions);
  }

  // Salta i valori che non hanno niente da mostrare: senza questo filtro
  // resterebbe una riga vuota per ognuno, e le definizioni ne dichiarano
  // parecchi che la regola non usava.
  valuesOf(item: DescribedItem): RuleCustomValue[] {
    return (item.customValues || []).filter(isCustomValueDisplayable);
  }
}
